<template>
  <div v-if="info">
    <el-dialog title="补全信息"
               center
               :visible.sync="isShow"
               width="500px"
               :close-on-click-modal="false"
               :before-close="close">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="90px"
               class="ruleForm">
        <el-form-item label="姓名"
                      prop="name">
          <el-input v-model="ruleForm.name"
                    placeholder="请输入姓名"
                    :disabled="info.userName!=null&&info.userName!=''"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="mobile">
          <el-input v-model="ruleForm.mobile"
                    placeholder="请输入手机号"
                    disabled></el-input>
        </el-form-item>
        <el-form-item label="身份证号"
                      prop="iDcard">
          <el-input v-model="ruleForm.iDcard"
                    placeholder="请输入身份证号"
                    :disabled="info.iDcard!=null&&info.iDcard!=''"></el-input>
        </el-form-item>
        <el-form-item label="单位"
                      prop="unit">
          <el-input v-model="ruleForm.unit"
                    placeholder="请输入单位"></el-input>
        </el-form-item>
        <el-form-item label="所在地区"
                      prop="area">
          <el-cascader v-model="ruleForm.area"
                       style="width:340px"
                       placeholder="请选择地区"
                       :options="arealist"></el-cascader>
          <span class="regionspan"
                v-show="ruleForm.area==1&&region!=''"
                @click.stop>{{region}}</span>
        </el-form-item>
        <el-form-item label="电子邮箱"
                      prop="mail">
          <el-input v-model="ruleForm.mail"
                    placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="科室">
          <el-select v-model="ruleForm.admoffId"
                     style="width:340px"
                     placeholder="请选择科室">
            <el-option v-for="(item,index) in AdmiOffIdOptions"
                       :key="index"
                       :label="item.valueText"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职称">
          <el-select v-model="ruleForm.professionalId"
                     style="width:340px"
                     placeholder="请选择职称">
            <el-option v-for="(item,index) in professionalIdOptions"
                       :key="index"
                       :label="item.valueText"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职务">
          <el-input v-model="ruleForm.duty"
                    placeholder="请输入职务"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom:0">
          <el-button type="primary"
                     style="margin-left:100px"
                     @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
      <!-- <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="close()">提交</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
import { areaList } from '@vant/area-data';
export default {
  props: {
    info: {
      type: Object,
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var checkMoblie = (rule, value, cb) => {
      const regMobile = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (regMobile.test(value)) {
        return cb()
      }
      cb(new Error('手机号格式错误'))
    }
    var checkIDcard = (rule, value, cb) => {
      const regMobile = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (regMobile.test(value)) {
        return cb()
      }
      cb(new Error('身份证号格式错误'))
    }
    return {
      uid: 0,
      ruleForm: {
        name: '',
        mobile: '',
        iDcard: '',
        unit: '',
        area: '',
        mail: '',
        admoffId: '',
        professionalId: '',
        duty: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMoblie, trigger: 'blur' }
        ],
        iDcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: checkIDcard, trigger: 'blur' }
        ],
        unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        area: [{ required: true, message: '请选择省市区县', trigger: 'change' }]
      },
      professionalIdOptions: [],
      AdmiOffIdOptions: [],
      arealist: [],
      region: ''
    };
  },
  watch: {
    isShow (type) {
      if (type) {
        this.ruleForm.name = this.info.userName == null ? '' : this.info.userName
        this.ruleForm.mobile = this.info.mobile
        this.ruleForm.iDcard = this.info.iDcard == null ? '' : this.info.iDcard
        this.ruleForm.unit = this.info.unit == null ? '' : this.info.unit
        // this.ruleForm.area = this.info.userName
        this.ruleForm.area = 1
        this.ruleForm.admoffId = this.info.admoffId == 0 ? '' : this.info.admoffId
        this.ruleForm.mail = this.info.mail == null ? '' : this.info.mail
        this.ruleForm.professionalId = this.info.professionalId == 0 ? '' : this.info.professionalId
        this.ruleForm.duty = this.info.duty == null ? '' : this.info.duty
        for (let a in areaList.province_list) {
          if (a == this.info.province) {
            this.region = areaList.province_list[a]
          }
        }
        for (let a in areaList.city_list) {
          if (a == this.info.city) {
            this.region = this.region + ' / ' + areaList.city_list[a]
          }
        }
        for (let a in areaList.county_list) {
          if (a == this.info.district) {
            this.region = this.region + ' / ' + areaList.county_list[a]
          }
        }
      }
    }
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id);
      this.getOptions(2)
      this.getOptions(3)
      this.getarealist();
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    getOptions (type) {
      this.httphelper
        .get('/api/BasicsmesApi/GetCodeResultList', {
          type: type
        })
        .then(res => {
          if (res.code == 200) {
            if (type == 2) {
              this.professionalIdOptions = res.data;
            } else if (type == 3) {
              this.AdmiOffIdOptions = res.data;
            }
          }
        })
    },
    getarealist () {
      for (let a in areaList.province_list) {
        this.arealist.push({
          value: a,
          label: areaList.province_list[a],
          children: []
        });
        for (let b in areaList.city_list) {
          if (b.substr(0, 2) == a.substr(0, 2)) {
            this.arealist[this.arealist.length - 1].children.push({
              value: b,
              label: areaList.city_list[b],
              children: []
            });
            for (let c in areaList.county_list) {
              if (c.substr(0, 4) == b.substr(0, 4)) {
                this.arealist[this.arealist.length - 1].children[this.arealist[this.arealist.length - 1].children.length - 1].children.push({
                  value: c,
                  label: areaList.county_list[c]
                });
              }
            }
          }
        }
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.area == 1) {
            this.ruleForm.area = [this.info.province, this.info.city, this.info.district]
          }
          this.httphelper
            .post('/api/CGpUserApi/UpdUserMessage', {
              id: this.uid,
              type: 2,
              mobile: this.ruleForm.mobile,
              nickname: this.info.nickname == null ? '' : this.info.nickname,
              introduction: this.info.introduction == null ? '' : this.info.introduction,
              unit: this.ruleForm.unit,
              userName: this.ruleForm.name,
              educatId: this.info.educatId == null ? 0 : this.info.educatId,
              admoffId: this.ruleForm.admoffId == '' ? 0 : this.ruleForm.admoffId,
              professionalId: this.ruleForm.professionalId == '' ? 0 : this.ruleForm.professionalId,
              idCard: this.ruleForm.iDcard,
              province: this.ruleForm.area[0],
              city: this.ruleForm.area[1],
              district: this.ruleForm.area[2],
              mail: this.ruleForm.mail
            })
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  message: '提交成功',
                  type: 'success'
                });
                this.$emit('togo')
              } else {
                this.$message({
                  message: '提交失败',
                  type: 'warning'
                });
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.ruleForm {
    width: 430px;
}
.regionspan {
    color: #606266;
    font-size: inherit;
    background-color: #fff;
    position: absolute;
    height: 36px;
    line-height: 36px;
    left: 15px;
    top: 2px;
}
</style>